var React = require('react');

function V1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"V1"),React.createElement("polygon",{"points":"33.68 84.24 50.48 42.12 67.28 0 33.64 0.01 0 0.03 16.84 42.14 33.68 84.24","fill":"#e5c83d","key":1})]);
}

V1.defaultProps = {"viewBox":"0 0 67.28 84.24"};

module.exports = V1;

V1.default = V1;
